import { User, BarChart2, Globe, MessageSquare, Award} from 'lucide-react';
import './CampusAmbassador.css';

function CampusAmbassadorProgram() {
  return (
    <div className="campus-page">
      {/* Hero Section */}
      <div className="hero-campus">
        <div className="hero-content-campus">
          <h1>Campus Ambassador Program</h1>
          <p>Become a quantum advocate at your institution and help build the future of quantum technology education.</p>
        </div>
      </div>

      {/* Program Overview */}
      <div className="campus-section overview-section">
        <h2>Program Overview</h2>
        <div className="overview-grid">
          <div className="overview-card">
            <div className="overview-icon-circle">
              <Award size={24} />
            </div>
            <h3>Learn</h3>
            <p>Gain advanced knowledge in quantum computing through exclusive workshops and learning materials.</p>
          </div>
          
          <div className="overview-card">
            <div className="overview-icon-circle">
              <Globe size={24} />
            </div>
            <h3>Connect</h3>
            <p>Build a network with quantum experts, researchers, and fellow ambassadors across institutions.</p>
          </div>
          
          <div className="overview-card">
            <div className="overview-icon-circle">
              <BarChart2 size={24} />
            </div>
            <h3>Grow</h3>
            <p>Develop leadership skills while helping to shape the future of quantum education.</p>
          </div>
        </div>
      </div>

      {/* Responsibilities */}
      <div className="campus-section responsibilities-section">
        <div className="responsibilities-content">
          <h2>Ambassador Responsibilities</h2>
          <div className="responsibilities-grid">
            <div className="responsibility-item">
              <div className="resp-icon">
                <MessageSquare size={20} />
              </div>
              <div>
                <h3>Organize Events</h3>
                <p>Host workshops, study groups, and seminars to spread awareness about quantum technologies.</p>
              </div>
            </div>
            
            <div className="responsibility-item">
              <div className="resp-icon">
                <User size={20} />
              </div>
              <div>
                <h3>Recruit Members</h3>
                <p>Encourage peers to join the quantum community and participate in activities.</p>
              </div>
            </div>
            
            <div className="responsibility-item">
              <div className="resp-icon">
                <Award size={20} />
              </div>
              <div>
                <h3>Represent</h3>
                <p>Act as the face of our quantum community at your institution and relevant events.</p>
              </div>
            </div>
            
            <div className="responsibility-item">
              <div className="resp-icon">
                <BarChart2 size={20} />
              </div>
              <div>
                <h3>Provide Feedback</h3>
                <p>Share insights about learning needs and help improve our educational materials.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Join Us Section */}
      <section className="ca-section cta">
        <div className="ca-container">
          <h2 className="ca-section-title">Ready to Join the Quantum Movement?</h2>
          <p className="ca-section-subtext">
            Be part of a transformative journey. Apply to the Campus Ambassador Program today.
          </p>
          <a 
            href="https://forms.gle/7iQdTfAq5hhQ1m6d7" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <button className="ca-btn ca-btn-primary">Apply Now</button>
          </a>
        </div>
      </section>

    </div>
  );
}

export default CampusAmbassadorProgram;